import React from 'react';
import useBgPages from '../../../../hooks/use-bg-pages.hook';
import Input from '../../../../components/forms/input.component';
import SimpleTitle from '../../../../components/forms/simple-titles.component';
import { useFunctionsButtons } from '../../../../hooks/use-function-button.hook';

function redirectButton({
  actionIndex,
  actionIndexCarrousel,
  index,
  indexCarrosuel,
  cardIndex,
  actionIndexSugestionsGeneral,
  type
}: {
  actionIndex?: any;
  actionIndexCarrousel?: any;
  index?: any;
  indexCarrosuel?: any;
  cardIndex?: any;
  actionIndexSugestionsGeneral?: any;
  type?: string;
}) {
  useBgPages();

  const {
    t,
    register,
    watch,
    errors,
    handleRemoveAction,
    handleKeyDown,
    handleRemoveActionCard,
    handleRemoveSuggestion
  } = useFunctionsButtons();

  return (
    <React.Fragment
      key={`action-call-${type === 'richCard' ? actionIndex : type === 'richCardCarrousel' ? actionIndexCarrousel : actionIndexSugestionsGeneral}`}
    >
      <div className="d-flex justify-content-between align-items-center mb-2">
        <SimpleTitle
          title="Redireccionar"
          type="info fw-bolder"
          subtitle={`Botón ${type === 'richCard' ? actionIndex + 1 : type === 'richCardCarrousel' ? actionIndexCarrousel + 1 : actionIndexSugestionsGeneral + 1}`}
        />
        <button
          type="button"
          className="btn btn-link text-danger fw-bolder p-0"
          onClick={() => {
            if (type === 'richCard') {
              handleRemoveAction(index, actionIndex);
            } else if (type === 'richCardCarrousel') {
              handleRemoveActionCard(indexCarrosuel, cardIndex, actionIndexCarrousel);
            } else if (type === 'suggestionsGeneral') {
              handleRemoveSuggestion(actionIndexSugestionsGeneral);
            }
          }}
        >
          Eliminar
        </button>
      </div>
      {type === 'richCard' && (
        <div className="row">
          <div className="col-md-6">
            <Input
              label={t('templates.rcs.create.url-tag')}
              requiredIndicator={'required'}
              placeholder={t('templates.rcs.create.url-tag-placeholder')}
              currentLength={
                (watch(`elements.${index}.actions.${actionIndex}.gnlLabel`) as string)?.length || 0
              }
              errors={errors?.elements?.[index]?.actions?.[actionIndex]?.gnlLabel}
              onKeyDown={(e: any) => handleKeyDown(e, 25)}
              {...register(`elements.${index}.actions.${actionIndex}.gnlLabel`, {
                required: true,
                maxLength: {
                  value: 25,
                  message: 'Máximo 25 caracteres'
                }
              })}
              maxLength={25}
            />
          </div>
          <div className="col-md-6">
            <Input
              label={t('templates.rcs.create.url-label')}
              requiredIndicator={'required'}
              placeholder={t('templates.rcs.create.url-placeholder')}
              errors={errors?.elements?.[index]?.actions?.[actionIndex]?.linkURL}
              {...register(`elements.${index}.actions.${actionIndex}.linkURL`, {
                required: true,
                pattern: {
                  value: /^(https?:\/\/[^\s$.?#].[^\s]*)$/i,
                  message: 'La URL no es válida, ejemplo: https://mi.dominio.com'
                }
              })}
            />
          </div>
        </div>
      )}
      {type === 'richCardCarrousel' && (
        <div className="row">
          <div className="col-md-6">
            <Input
              label={t('templates.rcs.create.url-tag')}
              requiredIndicator={'required'}
              placeholder={t('templates.rcs.create.url-tag-placeholder')}
              currentLength={
                (
                  watch(
                    `elements.${indexCarrosuel}.cards.${cardIndex}.actions.${actionIndexCarrousel}.gnlLabel`
                  ) as string
                )?.length || 0
              }
              errors={
                errors?.elements?.[indexCarrosuel]?.cards?.[cardIndex]?.actions?.[
                  actionIndexCarrousel
                ]?.gnlLabel
              }
              onKeyDown={(e: any) => handleKeyDown(e, 25)}
              {...register(
                `elements.${indexCarrosuel}.cards.${cardIndex}.actions.${actionIndexCarrousel}.gnlLabel`,
                {
                  required: true,
                  maxLength: {
                    value: 25,
                    message: 'Máximo 25 caracteres'
                  }
                }
              )}
              maxLength={25}
            />
          </div>
          <div className="col-md-6">
            <Input
              label={t('templates.rcs.create.url-label')}
              requiredIndicator={'required'}
              placeholder={t('templates.rcs.create.url-placeholder')}
              errors={
                errors?.elements?.[indexCarrosuel]?.cards?.[cardIndex]?.actions?.[
                  actionIndexCarrousel
                ]?.linkURL
              }
              {...register(
                `elements.${indexCarrosuel}.cards.${cardIndex}.actions.${actionIndexCarrousel}.linkURL`,
                {
                  required: watch(
                    `elements.${indexCarrosuel}.cards.${cardIndex}.actions.${actionIndexCarrousel}.gnlLabel`
                  )
                    ? true
                    : false,
                  pattern: {
                    value: /^(https?:\/\/[^\s$.?#].[^\s]*)$/i,
                    message: 'La URL no es válida, ejemplo: https://mi.dominio.com'
                  }
                }
              )}
            />
          </div>
        </div>
      )}
      {type === 'suggestionsGeneral' && (
        <div className="row">
          <div className="col-md-6">
            <Input
              label={t('templates.rcs.create.url-tag')}
              requiredIndicator={'required'}
              placeholder={t('templates.rcs.create.url-tag-placeholder')}
              currentLength={
                (watch(`suggestions.${actionIndexSugestionsGeneral}.gnlLabel`) as string)?.length ||
                0
              }
              errors={errors?.suggestions?.[actionIndexSugestionsGeneral]?.gnlLabel}
              onKeyDown={(e: any) => handleKeyDown(e, 25)}
              {...register(`suggestions.${actionIndexSugestionsGeneral}.gnlLabel`, {
                required: true,
                maxLength: {
                  value: 25,
                  message: 'Máximo 25 caracteres'
                }
              })}
              maxLength={25}
            />
          </div>
          <div className="col-md-6">
            <Input
              label={t('templates.rcs.create.url-label')}
              requiredIndicator={'required'}
              placeholder={t('templates.rcs.create.url-placeholder')}
              errors={errors?.suggestions?.[actionIndexSugestionsGeneral]?.linkURL}
              {...register(`suggestions.${actionIndexSugestionsGeneral}.linkURL`, {
                required: true,
                pattern: {
                  value: /^(https?:\/\/[^\s$.?#].[^\s]*)$/i,
                  message: 'La URL no es válida, ejemplo: https://mi.dominio.com'
                }
              })}
            />
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default redirectButton;
